import './Mobile.scss'
import logo from '../../assets/images/office-free-header-logo.svg'
import as from '../../assets/icons/as-icon.png'
import gp from '../../assets/icons/gp-icon.png'
import React from 'react'
import { Helmet } from 'react-helmet'

const Mobile = (props: any) => {
  return (
    <div className={'mobile'}>
      <Helmet>
        <title>Koç Office Free - Reservation</title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin."
        />
      </Helmet>
      <div className="row mb-4">
        <div className={'mobile-logo'} style={{ textAlign: 'center' }}>
          <img src={logo} className={'d-inline-block align-top'} alt="" style={{ width: '55%' }} />
        </div>
      </div>
      <div className={'row'}>
        <div className="mobile-desc pe-5 ps-5">
          <label className="mb-2">Koç Office Free</label>
          <p>
            Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir,
            istersen de uzaktan çalışma bildirimi yapabilirsin
          </p>
        </div>
      </div>
      <div className={'row'}>
        <div className={'mobile-link d-flex justify-content-center'}>
          <div className={'mobile-ps d-flex'}>
            <a className="app-btn blu flex vert" href="https://apps.apple.com/tr/app/office-free/id1571499394?l=tr">
              <img src={as} />
              <p style={{ textTransform: 'capitalize' }}>
                Download on the <br /> <span className="big-txt">App Store</span>
              </p>
            </a>
          </div>
          <div className={'mobile-ps d-flex'}>
            <a
              className="app-btn blu flex vert"
              href="https://play.google.com/store/apps/details?id=ist.pinsoft.android.remoteoffice&hl=tr&gl=US">
              <img src={gp} />
              <p>
                Get it on <br /> <span className="big-txt">Google Play</span>
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile
